import App from "./App.svelte";

const app = new App({
  target: document.body,
  props: {
    HTMLParent: document.getElementsByTagName("html")[0]
  }
});

export default app;
